/* src/app/module/service-provider/add-sp-new-component/technician-info/technician-info.component.scss */
.technician-info {
  max-width: 600px;
  margin: auto;
}
.heading {
  margin-bottom: 43px;
  font-size: 20px;
  font-weight: 600;
}
.total-technicians {
  margin: 20px 0;
  font-weight: bold;
}
button.btn.btn-primary {
  padding: 10px 15px;
  border-radius: 5px;
  margin-top: 43px;
  font-size: 16px;
  font-weight: 600;
}
.custom-input-number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #dfe1e5;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #fff;
}
.custom-input-number label {
  flex: 1;
  margin-right: 10px;
}
.custom-input-number p-inputNumber {
  flex: 2;
}
.custom-input-number p-inputNumber input {
  width: 80px !important;
  height: 40px !important;
}
.custom-input-number .p-inputnumber-button {
  width: 40px !important;
  height: 40px !important;
}
.custom-input-number .p-inputnumber-button .pi {
  font-size: 1.5rem;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(8, 12, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-bar {
  width: 100px;
  height: 10px;
  background-color: black;
  animation: load 2s infinite;
}
@keyframes load {
  0% {
    width: 0;
  }
  100% {
    width: 100px;
  }
}
form {
  width: 676px;
}
:host ::ng-deep .p-inputtext {
  margin-top: 0px;
  margin-bottom: 0px;
}
/*# sourceMappingURL=technician-info.component-RIGK54GA.css.map */
